import { Spinner } from "@blueprintjs/core";
import styled from 'styled-components';

const Cont = styled.div`
	margin: 20px;
`;

const Loading: React.SFC = () => (
	<Cont>
		<Spinner />
	</Cont>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/common/fragments/Loading.tsx